<template>
  <v-combobox multiple chips ref="combobox"
    label="Work Rights"
    placeholder="Select country"
    v-model="profile.workRights"
    @input="modify"
    @update:searchInput="focus"
    :items="countries"
    item-text="country"
    item-value="code"
    :filter="missingCountries"
    append-icon=""
    return-object
    :search-input.sync="search"
    :loading="loading"
    :color="themes.candidate.light.input"
    :menu-props="{ closeOnClick: true, closeOnContentClick: true, offsetY: true }"
    :attach="attach"
    :autofocus="autofocus"
  >
    <!-- Selection -->
    <v-chip avatar close
      slot="selection"
      slot-scope="data"
      :class="themes.candidate.light.chip"
      :selected="data.selected"
      :key="`work-right-${data.item.id}`"
      @input="remove(data.item.id)"
    >
      <v-avatar>
        <img :class="`flag-icon-background flag-icon-squared flag-icon-${data.item.countryCode.toLowerCase()}`" />
      </v-avatar>
      {{ data.item.country }}
    </v-chip>

    <!-- Options -->
    <v-list-tile avatar slot="item" slot-scope="data" @click="submit(data.item)">
      <v-list-tile-avatar>
        <img :class="`flag-icon-background flag-icon-squared flag-icon-${data.item.code.toLowerCase()}`" />
      </v-list-tile-avatar>
      <v-list-tile-content> <v-list-tile-title v-html="data.item.name" /> </v-list-tile-content>
    </v-list-tile>
  </v-combobox>
</template>

<script>
// Helpers
import _ from 'lodash'

// Data
import countries from '@/data/countries'

// Vue Component
export default {
  props: {
    attach: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    value: Array,
  },
  data() {
    return {
      // Data
      countries,
      // Loading indicator
      loading: false,
      // Search field
      search: '',
      // Model (object sent to API)
      profile: {
        workRights: JSON.parse(JSON.stringify(this.value)),
      },
    }
  },

  methods: {
    missingCountries(item, queryText) {
      const pattern = queryText.replace(/[^a-zA-Z\s]/g, '')
      return (
        !_.find(this.profile.workRights, ['countryCode', item.code]) &&
        new RegExp(pattern, 'i').test(item.name)
      )
    },

    modify(workRights) {
      // Create any that were newly added
      const newValue = workRights.filter(right => {
        return right.id && this.value.every(v => v.id !== right.id)
      })
      if (newValue && newValue[0]) this.submit(newValue[0])
      // Remove any that were removed with backspace
      const missingValues = this.value.filter(old => {
        return !_.some(workRights, newValue => newValue.id === old.id)
      })
      if (missingValues.length) this.remove(missingValues[0].id)
      // Remove work rights without ids
      this.profile.workRights = this.profile.workRights.filter(sr => sr.id)
    },

    submit(country) {
      this.loading = true
      this.$store
        .dispatch('candidate/workRights/create', {
          country: country.name,
          countryCode: country.code,
        })
        .finally(() => {
          this.reset()
        })
    },

    remove(id) {
      this.loading = true
      this.$store.dispatch('candidate/workRights/destroy', id).finally(() => {
        this.reset()
      })
    },

    reset() {
      this.$store.dispatch('candidate/profile/fetch').finally(() => {
        this.profile.workRights = JSON.parse(JSON.stringify(this.value))
        this.search = ''
        this.loading = false
      })
    },

    focus() {
      this.$refs.combobox.focus()
    },
  },
}
</script>
